import { render, staticRenderFns } from "./AutomationForm.vue?vue&type=template&id=5f76d333&"
import script from "./AutomationForm.vue?vue&type=script&lang=js&"
export * from "./AutomationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports